module.exports = __webpack_public_path__ + "img/2.5fb4a37b.jpg";